import { getEnvShopId } from '@core/config/shops';
import type { TenantShop } from './types';

let snapshot: TenantShop[] = [];

/** Updated by `TenantShopsProvider` so non-React code can read the catalog shop list. */
export function setTenantShopsSnapshot(shops: TenantShop[]) {
  snapshot = shops;
}

export function getTenantShopsSnapshot(): TenantShop[] {
  if (snapshot.length) return snapshot;
  return [{ id: getEnvShopId(), name: '' }];
}
